export default function Atlassian() {
  return (
    <>
      <svg
        width="144"
        height="19"
        viewBox="0 0 144 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="hidden md:block"
      >
        <title>Atlassian</title>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.695 1.054a11.343 11.343 0 00-.663 11.199l2.888 5.774a.513.513 0 00.46.279h5.984a.514.514 0 00.46-.745S9.771 1.448 9.568 1.046a.486.486 0 00-.874 0v.008zM5.539 8.871a.5.5 0 00-.85.091l-4.3 8.6a.513.513 0 00.46.745h5.984a.496.496 0 00.463-.288A8.828 8.828 0 005.54 8.87zm84.521 5.175c0-2.524-1.338-3.71-5.115-4.521-2.087-.461-2.59-.922-2.59-1.582 0-.835.746-1.185 2.13-1.185 1.69.054 3.35.466 4.871 1.208V4.65a11.017 11.017 0 00-4.764-.988c-3.733 0-5.665 1.624-5.665 4.281l.006.003c0 2.129.99 3.818 4.852 4.564 2.305.484 2.783.856 2.783 1.624 0 .746-.484 1.23-2.107 1.23a11.894 11.894 0 01-5.598-1.515v3.468a11.453 11.453 0 005.555 1.208c4.036 0 5.642-1.8 5.642-4.478zm40.772-10.164v14.425h3.073V7.312l1.296 2.922 4.347 8.08h3.863V3.882h-3.073v9.309l-1.163-2.7-3.491-6.609h-4.852zm-22.91 0h3.358v14.425h-3.358V3.882zm-3.875 10.162c0-2.525-1.339-3.71-5.114-4.522-2.088-.46-2.59-.922-2.59-1.581 0-.835.745-1.186 2.129-1.186 1.691.055 3.351.466 4.871 1.208V4.65a11.013 11.013 0 00-4.764-.988c-3.733 0-5.665 1.624-5.665 4.281 0 2.13.989 3.821 4.852 4.567 2.305.484 2.784.856 2.784 1.624 0 .746-.485 1.23-2.107 1.23a11.894 11.894 0 01-5.598-1.515v3.468a11.453 11.453 0 005.554 1.208c4.037 0 5.643-1.8 5.643-4.478l.005-.003zm-51.21 4.263V3.882h3.382V15.19h4.61l-1.086 3.118h-6.905zM39.198 3.882v3.114h3.733v11.307h3.38V6.996h3.997V3.878l-11.11.004zm-9.333 0h4.43l5.027 14.425H35.48l-.713-2.429a9.547 9.547 0 01-5.379 0l-.713 2.429h-3.841l5.03-14.425zm.367 9.128a6.56 6.56 0 001.849.265v.003c.625 0 1.248-.088 1.848-.264L32.08 6.717 30.23 13.01zm41.414-9.128h-4.43l-5.03 14.425h3.841l.713-2.429a9.547 9.547 0 005.379 0l.713 2.429h3.84L71.646 3.882zm-2.216 9.393a6.56 6.56 0 01-1.848-.265l1.848-6.296 1.848 6.297c-.6.176-1.222.265-1.848.264zm49.526-9.393h4.43l5.029 14.425h-3.843l-.713-2.429a9.546 9.546 0 01-5.379 0l-.713 2.429h-3.841l5.03-14.425zm.364 9.128a6.566 6.566 0 003.697.001l-1.848-6.297-1.849 6.296z"
          fill="#9DA6C7"
        />
      </svg>

      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        className="md:hidden"
      >
        <path
          d="M11.866 18.464a1.139 1.139 0 00-1.936.21L.125 38.28a1.171 1.171 0 001.047 1.698h13.645a1.13 1.13 0 001.057-.657 20.127 20.127 0 00-4.008-20.858zM19.062.643a25.862 25.862 0 00-1.51 25.532l6.584 13.166a1.171 1.171 0 001.047.634h13.645a1.172 1.172 0 001.047-1.697S21.518 1.54 21.055.624a1.107 1.107 0 00-1.993 0v.02z"
          fill="#9DA6C7"
        />
      </svg>
    </>
  );
}
